import { render, staticRenderFns } from "./OrderEmail.vue?vue&type=template&id=6ce68248"
import script from "./OrderEmail.vue?vue&type=script&lang=js"
export * from "./OrderEmail.vue?vue&type=script&lang=js"
import style0 from "./OrderEmail.vue?vue&type=style&index=0&id=6ce68248&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports